import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import Context from '../../Context'
import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { AiOutlineHome } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { ModalLogin } from '../ModalLogin';
import { Navbar,Nav,NavDropdown } from 'react-bootstrap';


export const Cabecera = (props) => {

    
    const history = useHistory();
    const [mostrarImagen, setMostrarImagen] = useState('masthead imagen'); 
    const [textoCabecera, setTextoCabecera] = useState(''); 
    useEffect(() => {
        let classCabecera = 'masthead imagen'
        props.imagen ? classCabecera = 'masthead imagen' : classCabecera = 'masthead'
        props.clase ? classCabecera = classCabecera+" "+props.clase : classCabecera = classCabecera
        setMostrarImagen(classCabecera);
    },[mostrarImagen]);
      

    let classcabecera = props.top ? 'cabecera cabeceraFixed' : 'cabecera'
    let txtcabecera = props.texto ? props.texto : ''
   
    
    const cerrarSesion = async () => {
        props.removeAuth()
        history.push(`/`)
    }
    const editarPerfil = async () => {
        
        history.push(`/editarperfil`)
    }
    

    const [sectores, setSectores] = useState(false)

   

    const fetchSectores = async () => {
        let dataFormEventos = {  
            "tipoCategoria": "categoria"
         }
        
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },  
        };
        axios.post(`${process.env.REACT_APP_URL_API}formatos/ObtenerCategorias`, dataFormEventos, axiosConfig)
        .then((res) => {
        
            setSectores(res.data.data)
        })
        .catch((err) => {
            
        }) 
    }

    useEffect(() => {
        fetchSectores();
    },[])

    if(!sectores) { return(<div></div>) } 
    return  (
        <Context.Consumer>
            {
                ({isAuth,modaIsOpen,activateAuth,modaToggle,showRecovery,showRecoveryToggle,showRegistroToggle,showRegistro,logEvento,idEventoSeleccionado}) => {
                return(
                    <Fragment>
                        <div className={classcabecera}>
                         <div className="shadowHeader">   
                        <div className="container">
                        <Navbar bg="light" expand="lg" id="mainNav">
                        <div className="logos-cabecera">
                            <span className="navbar-brand" ><img src={process.env.PUBLIC_URL + '/assets/images/adnpymes_logo.png'}/></span>
                        </div>
                        
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        
                        <Navbar.Collapse id="basic-navbar-nav" >
                          <Nav className="mr-auto justify-content-end">
                            <Nav.Link as={Link} to="/"><AiOutlineHome color='#D9A76A' size='20px' /> Home</Nav.Link>
                            
                            
                            
                          </Nav>
                        </Navbar.Collapse>
                      </Navbar>
                      </div>
                      </div>

                            {
                                props.imagen &&
                        
                                <header className={mostrarImagen} style={ props.urlimagen && {backgroundImage: `url(${props.urlimagen})`} } >
                                    <div className="container h-100">
                                    <div className="row h-100 align-items-center">
                                        <div className="col-md-12">
                                        <div className="full-w">
                                            
                                            <div dangerouslySetInnerHTML={{__html: txtcabecera} }/>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </header>
                            }
                        </div>
                        {modaIsOpen && 
                            <ModalLogin modaToggle={modaToggle} activateAuth={activateAuth} showRecovery={showRecovery} showRecoveryToggle={showRecoveryToggle} showRegistro={showRegistro} showRegistroToggle={showRegistroToggle} logEvento={logEvento} />
                        }
                    </Fragment>
                )
            }
        }   
        </Context.Consumer>
        
    )
    
}